module.exports = __webpack_public_path__ + "img/ftr-bl.9c76460a.png";